import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="promoters--event-groups--publish"
export default class extends Controller {
  static outlets = ["modal"];
  static values = {
    publishStatus: String,
  };

  connect() {}

  showConfirm() {
    const confirm_message = document.getElementById("modal-confirm-message");
    const title = document.getElementById("event_group_title").value;
    if (this.publishStatusValue == "published") {
      confirm_message.textContent = title + "を更新します。";
      confirm_message.innerHTML += "<br />よろしいですか？";
    } else {
      let specific_checked = document.getElementById("publish_option_specific").checked;

      let date = document.getElementById("event_group_published_at_date").value;
      let hour = document.getElementById("event_group_published_at_hour").value.padStart(2, "0");
      let min = document.getElementById("event_group_published_at_min").value.padStart(2, "0");
      let published_at = date + " " + hour + ":" + min;

      if (specific_checked) {
        confirm_message.textContent = published_at + "に" + title + "を公開します。";
      } else {
        confirm_message.textContent = title + "を公開します。";
      }
      confirm_message.innerHTML += "<br />よろしいですか？";
    }

    this.modalOutlets.forEach((x) => x.show());
  }
}
